import { memo } from "react";

import GhostEnvironmentConnectedSource from "./ConnectedSource";

// -----------------------------------------------------------------------------

const GhostEnvironmentConnectedSources = memo(
  function GhostEnvironmentConnectedSources() {
    return (
      <>
        <GhostEnvironmentConnectedSource />
        <GhostEnvironmentConnectedSource />
        <GhostEnvironmentConnectedSource />
        <GhostEnvironmentConnectedSource />
      </>
    );
  }
);

export default GhostEnvironmentConnectedSources;
